// src/components/white-screen-tool/constants.ts
export const PREDEFINED_COLORS = [
  { name: 'White', hex: '#FFFFFF', url: 'white-screen' },
  { name: 'Red', hex: '#FF0000', url: 'red-screen' },
  { name: 'Green', hex: '#00FF00', url: 'green-screen' },
  { name: 'Blue', hex: '#0000FF', url: 'blue-screen' },
  { name: 'Black', hex: '#000000', url: 'black-screen' },
  { name: 'Yellow', hex: '#FFFF00', url: 'yellow-screen' },
  { name: 'Orange', hex: '#FFA500', url: 'orange-screen' },
  { name: 'Pink', hex: '#FFC0CB', url: 'pink-screen' },
  { name: 'Purple', hex: '#800080', url: 'purple-screen' }
];

export const RESOLUTIONS = [
  { label: '720p', width: 1280, height: 720 },
  { label: '1080p', width: 1920, height: 1080 },
  { label: '1440p', width: 2560, height: 1440 },
  { label: '4K', width: 3840, height: 2160 },
];